<section class="order-section relative">
  <div class="icon-text header">
    <div class="custom-icon order_lrg_cir_white"></div>
    <h1>Orders</h1>
  </div>
  <mat-icon
    class="!h-36 !w-36 absolute text-[9.25rem] leading-none opacity-25 left-1/4 top-1/4 text-center self-center"
    >check_circle</mat-icon
  >
  <div class="order_content">
    <!-- Ticket Count -->
    @if (isLoading$ | async) {
      <div class="loading-indicator">
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>
    } @else {
      <div class="order_count">
        <div class="number">{{ (totalOpenOrders$ | async).length }}</div>
        <div class="description">
          <div class="order_status upper">Active</div>
          <div class="order_label">
            {{ totalOpenOrders$ | async | pluralize: 'Order' }}
          </div>
        </div>
      </div>
      <!-- Ticket Icon -->
      <div class="order_icon">
        <div class="total-locations">
          Spanning {{ totalActiveLocations$ | async }}
          {{ totalActiveLocations$ | async | pluralize: 'location' }}
        </div>
      </div>
    }
  </div>
  <div class="widget_cta"><a routerLink="/orders">View Orders</a></div>
  <a routerLink="/orders" tabindex="-1" class="dashboard-link desktop"
    ><div class="cta-link">desktop</div></a
  >
</section>
